module.exports = __webpack_public_path__ + "img/g2.767b48b6.png";